import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment-timezone';

export default Vue.component('previous-transactions', {
  template: require('./template.html'),
  name: 'previous-transactions',
  computed: {
    ...mapGetters(['websites', 'currentUser']),
  },
  data() {
    return {
      showPreviousTransactions: false,
    };
  },
  props: ['transactions'],
  methods: {
    getDollars(amount) {
      // this will format the penny values given by stripe to dollars
      return (amount / 100)
        .toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        });
    },
    formatDate(date) {
      return moment.unix(date).format('MM/DD/YY');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/account/billing/previous-transactions/index.js